import { render } from "./Item.vue?vue&type=template&id=2cc110e8"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=2cc110e8&lang=scss"
script.render = render

export default script